import Vue from 'vue';
import { ILogEntry } from '@/common/logging/Logger';
import { RootState } from '../types';
import { Module, GetterTree, ActionTree, MutationTree } from 'vuex';
import VuexPersistence from 'vuex-persist';

export interface ILoggingState {
    entries: ILogEntry[];
    entriesByTag: {[tag: string]: ILogEntry[] };
}

const state: ILoggingState = {
    entries: [],
    entriesByTag: {},
};
const getters: GetterTree<ILoggingState, RootState> = {
};
const actions: ActionTree<ILoggingState, RootState> = {
};
const mutations: MutationTree<ILoggingState> = {
    log(logState, entry: ILogEntry) {
        Vue.set(logState.entries, logState.entries.length, entry);
        let entriesByTag = logState.entriesByTag[entry.tag];
        if (!entriesByTag) {
            Vue.set(logState.entriesByTag, entry.tag, (entriesByTag = []));
        }
        Vue.set(entriesByTag, entriesByTag.length, entry);
        if (entriesByTag.length > 20) {
            entriesByTag.shift();
        }
        if (logState.entries.length > 50) {
            logState.entries.shift();
        }
    },
    clear(logState) {
        Vue.set(state, 'entries', []);
        Vue.set(state, 'entriesByTag', {});
    },
};


export const logging: Module<ILoggingState, RootState> = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
